import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { AddressActions } from './address.actions';

@Injectable({
  providedIn: 'root'
})
export class AddressEffects {
  sendAddressEffect$: Observable<Action>;

  constructor(private actions$: Actions) {
    this.sendAddressEffect$ = createEffect(
      (): any =>
        this.actions$.pipe(
          ofType(AddressActions.submitSuccess),
          tap(() => {})
        ),
      { dispatch: false }
    );
  }
}
